import { Container, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import { isUserAdmin, isUserLoggedIn, } from "../utils/utils";
import { Backend } from "../services/Backend";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";

export default function Header() {
    const [user, setUser] = useState({});

    const isLoggedIn = isUserLoggedIn();
    const isAdmin  = isUserAdmin();

    useEffect(() => {
        if (isLoggedIn) {
            Backend.get("user/me").then(res => setUser(res));
        }
    },[]);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
      setAnchorEl(null);
    };

    const logout = () => {
        const cookie = new Cookies();
        cookie.remove('jwt', { path: '/' });

        window.location.href = '/';
    }

    return  <div className=" border-b border-grey border-1">
        <Container maxWidth="lg" className="my-3  ">
            <div className="flex items-center gap-5">
                <img src="/img/logo.png" className="block w-[250px]"/>
                <Link to="/" className="ml-auto">Home</Link>
                { isLoggedIn && <Link to="/submit-your-best-practice">Submit your best practice</Link> }
                <Link to="/search-best-practice">Search best practice</Link>
                <Link to="/news">News</Link>
                <Link to="https://www.chemical-logistics.org/committee-for-best-practices-in-chemical-logisticslogistics">Committee BSP</Link>
                <Link to="/about-us">About us</Link>
                
                {!isLoggedIn ?<>
                    <Link to="/signin">Login</Link>
                    <Link to="/register">Register</Link>
                </> : <b onClick={handleClick} className="cursor-pointer">{user.firstName} {user.lastName}</b>}
                
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}

                >
                    {isAdmin ? <MenuItem onClick={handleClose}><Link to="/dashboard/users">Dashboard</Link></MenuItem>: ""}
                    <Link to="/profile/info"><MenuItem onClick={handleClose}>Profile</MenuItem></Link>
                    <Link to="/submit-url"><MenuItem onClick={handleClose}>Add Url</MenuItem></Link>
                    <Link><MenuItem onClick={logout}>Logout</MenuItem></Link>
                </Menu>
               
            </div>
        </Container>
    </div>
}